import { apiFetch } from '@app/utils/utils';
import { AdminDriverSchedule, ScheduleResponse } from '@app/Schedules/types';
import { AdminCampaignRun } from '@app/Campaigns/types';

const BASE = '/api/admin/schedules';

/** All drivers' weekly availability (the all-drivers grid). */
export async function getAllSchedules(
  opts: { q?: string; limit?: number; offset?: number } = {}
): Promise<AdminDriverSchedule[]> {
  const params = new URLSearchParams();
  if (opts.q) params.set('q', opts.q);
  if (opts.limit != null) params.set('limit', String(opts.limit));
  if (opts.offset != null) params.set('offset', String(opts.offset));
  const qs = params.toString();
  const res = await apiFetch(`${BASE}${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Failed to load schedules (${res.status})`);
  return res.json();
}

/** One driver's weekly availability (always 7 days). */
export async function getDriverSchedule(driverProfileId: number): Promise<ScheduleResponse> {
  const res = await apiFetch(`${BASE}/${driverProfileId}`);
  if (res.status === 404) throw new Error('Driver not found');
  if (!res.ok) throw new Error(`Failed to load schedule (${res.status})`);
  return res.json();
}

/** Booked runs whose slot starts in [from, to). from/to are ISO-8601 instants. */
export async function getRunCalendar(
  opts: { from?: string; to?: string; driverProfileId?: number } = {}
): Promise<AdminCampaignRun[]> {
  const params = new URLSearchParams();
  if (opts.from) params.set('from', opts.from);
  if (opts.to) params.set('to', opts.to);
  if (opts.driverProfileId != null) params.set('driverProfileId', String(opts.driverProfileId));
  const qs = params.toString();
  const res = await apiFetch(`${BASE}/runs${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Failed to load run calendar (${res.status})`);
  return res.json();
}
